import { getAccessToken } from "../authentication/AuthenticationService";

export interface UserData {
	firstName: string;
	lastName: string;
	email: string;
}

export function getProfile(): Promise<UserData> {
	const requestOptions = {
		headers: { Authorization: "Bearer " + getAccessToken() }
	};

	return fetch("/api/users/me", requestOptions).then(response => {
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}

		return response.json();
	});
}
